export const contactEmail = "cryptex.eri@gmail.com";

export const rrss = {
  x: "https://x.com/retoimposible",
  ig: "https://www.instagram.com/retoimposible/",
  dc: "https://discord.com/invite/ZgrrnMbUQs",
  pp: "https://www.paypal.com/paypalme/areguz22",
  kf: "https://ko-fi.com/retoimposible",
  gm: "mailto:cryptex.eri@gmail.com"
};

export const footerMenu = [
  { label: "El Reto Imposible", path: "/" },
  { label: "Contacto", path: "/contacto" },
  { label: "Términos legales", path: "/terminos-legales" },
];
